import * as React from "react";
import querystring from "querystring";
import styled from "styled-components";

import Gettext, { withGettext } from "../../common/Gettext";
import { withFetch } from "../../common/fetch";

import { LOGIN_TAB_ID, PASSWORD_RESTORE_TAB_ID } from "../Auth";
import Message from "../Message";
import ErrorMessage from "../ErrorMessage";
import BtnFormSubmit from "../BtnFormSubmit";
import Input from "../Input";

import Container from "../StyledComponents/Container";
import Link from "../StyledComponents/FakeLink";
import validators from "../validators";

const SubmitContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  text-align: center;
  vertical-align: middle;
  padding: 11px 0;
  height: 68px;
`;

const FormText = styled.p`
  padding: 20px 20px 9px 20px;
  margin: 0;
  font-size: 18px;
  font-weight: 300;
  line-height: 1.2;
  color: #fff;
`;

const ForgotContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 10px;
`;

const ForgotLink = styled(Link)`
  display: inline-block;
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "14px"};
  line-height: 1.2;
  text-decoration: none;
  color: #feac00;
  cursor: pointer;
  transition: all 0.2s ease;

  :hover {
    color: #ffc54c;
  }

  :active {
    color: #ffc54c;
  }

  :focus {
    color: #ffc54c;
  }
`;

type State = {
  pending: "host" | null,
  submitTimeError: string | React.Node | null,
  responseTimeError: string | null
};

class SocialPassword extends React.Component<$FlowFixMeProps, State> {
  state = {
    pending: null,
    submitTimeError: null,
    responseTimeError: null
  };

  login = async (event: SyntheticEvent<HTMLButtonElement>) => {
    event.preventDefault();

    // TODO: validate
    const { email, password, locale } = this.props;
    const { fb_id, gp_id } = this.props.query;

    const submitTimeError =
      validators.emptyFields(email, password) ||
      validators.emailFull(email) ||
      validators.password(password);

    if (submitTimeError) {
      this.setState({ submitTimeError });
      return;
    }

    this.setState({ pending: "host" });

    const credentials = querystring.stringify({
      email,
      password,
      locale,
      ...(fb_id ? { fb_id } : { gp_id })
    });

    try {
      const response = await this.props.fetch(`/auth-user?${credentials}`, {
        unstable_dontInferResponse: true
      });

      this.setState({ pending: null });

      switch (response.status) {
        case "OK":
          this.props.dispatch({ type: "REQUEST_PROFILE" });
          this.dismiss();
          this.props.dispatch({ type: "REQUEST_DEAL_HISTORY" });
          break;
        case "ERROR":
          if (response.must_confirm_phone) {
            // this.props.onLeave(PHONE_CONFIRM_TAB_ID);
          } else {
            this.setState({ responseTimeError: response.message });
          }
          break;
        default:
          break;
      }
    } catch (error) {
      console.error(error);
    }
  };

  handleInputChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({
      submitTimeError: null,
      responseTimeError: null
    });

    this.props.onInputChange(event);
  };

  dismiss = (event, f) => {
    event != null && event.preventDefault();
    this.props.history.replace({
      ...this.props.location,
      search: ""
    });
    if (typeof f === "function") {
      f();
    }
  };

  goToForgot = () => {
    this.dismiss();
    this.props.onLeave(PASSWORD_RESTORE_TAB_ID);
  };

  render() {
    const { email, password, notification, query } = this.props;
    const { pending, submitTimeError, responseTimeError } = this.state;

    if (!query) return null;

    const inputTimeError = validators.email(email);

    return (
      <Container>
        <div>
          <FormText>
            {query.fb_id ? (
              <Gettext>
                The e-mail address that you use on Facebook is already
                registered in our database. If you want to login using Facebook
                now, please enter your password below:
              </Gettext>
            ) : (
              <Gettext>
                Your e-mail address that you use on Google is already registered
                in our database. If you want to login using Google now, please
                enter your password below:
              </Gettext>
            )}
          </FormText>
        </div>
        <Input
          type="password"
          name="password"
          placeholder={this.props.gettext`Password`}
          id="login-pass"
          onChange={this.handleInputChange}
          value={password}
        />

        {responseTimeError ? (
          <ErrorMessage message={responseTimeError} />
        ) : submitTimeError ? (
          <ErrorMessage message={submitTimeError} />
        ) : notification ? (
          <Message notification={notification} />
        ) : inputTimeError ? (
          <ErrorMessage message={inputTimeError} />
        ) : null}

        <SubmitContainer>
          <BtnFormSubmit
            onClick={e =>
              this.dismiss(e, () => this.props.onLeave(LOGIN_TAB_ID))
            }
            cancelButton={true}
          >
            <Gettext>Cancel</Gettext>
          </BtnFormSubmit>
          <BtnFormSubmit
            id="login"
            onClick={this.login}
            loader={pending === "host"}
          >
            <Gettext>login</Gettext>
          </BtnFormSubmit>
        </SubmitContainer>

        <ForgotContainer>
          <ForgotLink onClick={this.goToForgot}>
            <Gettext>Forgot password?</Gettext>
          </ForgotLink>
        </ForgotContainer>
      </Container>
    );
  }
}

export default withGettext(withFetch(SocialPassword));



// WEBPACK FOOTER //
// ./src/components/Auth/Tabs/SocialPassword.js